import type { ReactNode } from 'react'
import { memo } from 'react'
import { Popconfirm } from 'antd'
import './pop-confirm.css'

export interface PopConfirmProps {
  content?: ReactNode
  children?: ReactNode
  cancelText?: string
  okText?: string
  buttonHeight?: string
  title?: ReactNode
  icon?: ReactNode
  isLoading?: boolean
  open?: boolean
  placement?:
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom'
  onConfirm?: (...args: any[]) => void
  onCancel?: (...args: any[]) => void
  onOpenChange?: (open: boolean) => void
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement
  trigger?: 'click' | 'hover' | 'focus'
  okTextEnglish?: string
  cancelTextEnglish?: string
  disabled?: boolean
  destroyTooltipOnHide?: boolean
  bgColor?: string
  style?: React.CSSProperties
}

function PopConfirmInner({
  content,
  children,
  cancelText = 'Cancel',
  okText = 'Confirm',
  buttonHeight = '32px',
  title,
  icon,
  isLoading,
  open,
  placement = 'top',
  onConfirm,
  onCancel,
  onOpenChange,
  getPopupContainer,
  trigger,
  okTextEnglish,
  disabled,
}: PopConfirmProps) {
  return (
    <div className="glasspro-pop-confirm flex items-center justify-center w-full h-full">
      <Popconfirm
        open={open}
        icon={icon || null}
        title={title}
        description={content}
        onCancel={onCancel}
        onConfirm={onConfirm}
        onOpenChange={onOpenChange}
        getPopupContainer={getPopupContainer}
        trigger={trigger}
        cancelText={cancelText}
        okText={okText}
        okButtonProps={{
          disabled: isLoading || disabled || false,
          danger: okText === 'Delete' || okTextEnglish === 'Denied',
          style: disabled
            ? {
                height: buttonHeight,
                borderRadius: '0px',
                padding: '6px 15px',
                backgroundColor: '#c4c4c4',
                color: '#212121',
                border: 'none',
                pointerEvents: 'none' as const,
                boxShadow: 'none',
              }
            : {
                height: buttonHeight,
                borderRadius: '0px',
                padding: '6px 15px',
                backgroundColor: 'var(--primary-btn-bg)',
                color: 'var(--primary-btn-text, #ffffff)',
              },
        }}
        cancelButtonProps={{
          disabled: false,
          style: {
            height: buttonHeight,
            borderRadius: '0px',
            padding: '6px 15px',
            border: '0.5px solid var(--secondary-btn-bg)',
            backgroundColor: 'var(--secondary-btn-bg)',
            color: 'var(--secondary-btn-text, #212121)',
          },
        }}
        placement={placement}
      >
        {children}
      </Popconfirm>
    </div>
  )
}

export const PopConfirm = memo(PopConfirmInner)
